'use client';

import { ReactNode, useMemo } from 'react';

import { redirect, usePathname } from 'next/navigation';
import { pathToRegexp } from 'path-to-regexp';

import ROUTES_MAP from '@/config/routes';

import { isRegExp } from '../helpers/utils/typeGaurds';

// Optimization Changes Flag - Synchronous route validation
const RevalidateRoutes = ({ children, isBackoffice }: { children: ReactNode; isBackoffice: boolean }) => {
  const pathname = usePathname();

  // Optimization Changes Flag - useMemo for synchronous validation (eliminates render blocking)
  const shouldRenderChildren = useMemo(() => {
    const otherGroup = isBackoffice ? 'REPLICATED_ROUTES' : 'BACKOFFICE_ROUTES';
    const currentPath = pathname;
    const isAccessingRoutesFromOtherGroups = ROUTES_MAP[otherGroup]
      .map(route => {
        try {
          return pathToRegexp(route);
        } catch (err) {
          return route;
        }
      })
      .some(rx => (isRegExp(rx) ? rx.test(currentPath) : rx === currentPath));

    return !isAccessingRoutesFromOtherGroups;
  }, [pathname, isBackoffice]);

  if (!shouldRenderChildren) {
    console.log('redirecting to not found - user trying to access routes from other groups.');
    redirect('/not-found');
  }

  return children;
};

export default RevalidateRoutes;
